import { departmentSchedule } from 'core/department_schedules.js';
export var scheduleRotations = (function($, window, document) {

  // Match ShiftRequirement::MAX_INT (ActiveRecord 32-bit signed integer max)
  const MAX_INT = 2147483647;

  var rotationId;
  var rotationLength;
  var rotationBlueprint;
  var config;
  var rotationLoadingPrompt;
  var init = false;

  init = function(settings) {
    config = {
      privatePusherChannel: settings.privatePusherChannel,
      routes: {
        createDepartmentRotationPath: settings.createDepartmentRotationPath
      }
    }

    Handlebars.registerHelper('isPublished', function(published) {
      if (published) {
        return new Handlebars.SafeString("<strong>" + I18n.t('rotations.js.published') + "</strong>");
      } else {
        return new Handlebars.SafeString("<strong>" + I18n.t('rotations.js.unpublished') + "</strong>");
      }
    });

    Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
      return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
    });

    Handlebars.registerHelper('remainingErrors', function(totalErrors, displayedErrors) {
      var remainingErrors = totalErrors - displayedErrors.length;

      if (remainingErrors > 0) {
        return new Handlebars.SafeString("<li>And " + remainingErrors + " more...</li>");
      } else {
        return "";
      }
    });

    init = true;

    registerPusherEvents();
  }

  var registerPusherEvents = function() {
    if (config.privatePusherChannel) {

      config.privatePusherChannel.bind('rotation-create.confirm', function(data) {
        openConflictDialogue(data.payload, data);
      });

      config.privatePusherChannel.bind('rotation-create.success', function(data) {
        var rowPosition = departmentSchedule.getCurrentRowPosition();
        departmentSchedule.loadSchedule(location.href, rowPosition);
        hideLoader();
      });

      config.privatePusherChannel.bind('rotation-create.failure', function(data) {
        hideLoader();
      });
    }
  };

  var openModal = function(ui, obj) {
    var $td = obj;
    var $tr = $td.closest('tr');
    var $th = $('.floatThead-table').find('th').eq($td.index());
    var startDate = moment($th.attr('data-date')).toDate();
    var userId = $tr.data('user-id');
    var positionId = $tr.data('position-id');
    var jobSiteId = $tr.data('job-site-id');
    rotationId = ui.draggable.data("rotation-id");
    rotationLength = ui.draggable.data("rotation-length");
    rotationBlueprint = ui.draggable.data("rotation-blueprint");

    // Determine target type and ID based on which view we're in
    var targetType, targetId;
    if (userId) {
      targetType = 'user';
      targetId = userId;
    } else if (positionId) {
      targetType = 'position';
      targetId = positionId;
    } else if (jobSiteId) {
      targetType = 'job_site';
      targetId = jobSiteId;
    }

    openDatePrompt(startDate, targetType, targetId);
  }

  var openDatePrompt = function(startDate, targetType, targetId) {
    var rotationDays = Object.keys(rotationBlueprint).length - 1;
    var nextDay = startDate.clone().add(rotationDays).day();
    var dialogMessage = buildDialogMessage(nextDay, targetType);

    var buttons = [];
    buttons.push({"label": "Cancel", "callback": function() {}});
    buttons.push({ "label" : "Ok", "class" : "btn-blue", "callback": function() {
        // Validate before submission (mimics Rails simple_form validation)
        if (targetType === 'position' || targetType === 'job_site') {
          var input = $('#rotation-required-employees');
          var value = parseInt(input.val(), 10);
          var controlGroup = $('#rotation-required-employees-control-group');
          var errorSpan = $('#rotation-required-employees-error');
          var errorMessage = '';

          // Clear previous errors
          controlGroup.removeClass('error');
          errorSpan.hide().text('');

          // Validate like ShiftRequirement model: presence: true, numericality: { only_integer: true, greater_than_or_equal_to: 1, less_than: MAX_INT }
          if (!input.val() || input.val().trim() === '') {
            errorMessage = 'can\'t be blank';
          } else if (isNaN(value)) {
            errorMessage = 'is not a number';
          } else if (input.val().indexOf('.') !== -1 || value !== parseFloat(input.val())) {
            errorMessage = 'must be an integer';
          } else if (value < 1) {
            errorMessage = 'must be greater than or equal to 1';
          } else if (value >= MAX_INT) {
            errorMessage = `must be less than ${MAX_INT}`;
          }

          if (errorMessage) {
            controlGroup.addClass('error');
            errorSpan.text(errorMessage).show();
            return false; // Prevent modal from closing
          }
        }
        createRotation(startDate, $("input#rotation-end-date").val(), targetType, targetId);
      }
    });

    var headerText = I18n.t('rotations.js.new_rotation');
    bootbox.dialog(
      $(dialogMessage),
      buttons,
      {"header": headerText});

    $('.datepicker').datepicker({ weekStart: MKS.departmentStartOfWeek, language: I18n.locale }).datepicker('setStartDate', startDate).on('changeDate', function(e) {
      $(this).parent().find('input#rotation-end-date').val($.datepicker.formatDate( "yy-mm-dd", e.date ));
    });
  }

  var createRotation = function(startDate, endDate, targetType, targetId) {
    var payload = {
      rotationId: rotationId,
      targetType: targetType,
      targetId: targetId,
      startDate: startDate,
      endDate: endDate
    }

    // Add required_employees if applicable (position or job_site schedules)
    // Value is already validated at this point
    if (targetType === 'position' || targetType === 'job_site') {
      var requiredEmployees = parseInt($("input#rotation-required-employees").val(), 10);
      payload.requiredEmployees = requiredEmployees;
    }

    postData(payload);
  }

  var showLoader = function() {
    var promptContent = HandlebarsTemplates['rotations/rotation_loading']({
      adding_rotation: I18n.t('rotations.js.adding_rotation'),
      warning: I18n.t('rotations.js.warning'),
      warning_detail: I18n.t('rotations.js.warning_detail')
    });
    rotationLoadingPrompt = bootbox.dialog(promptContent, [], {
      "header": I18n.t('rotations.js.creating')
    });
  }

  var hideLoader = function() {
    if (rotationLoadingPrompt) {
      rotationLoadingPrompt.modal('hide');
    }
  }

  var postData = function(payload, forceSave) {

    showLoader();

    var targetType = payload.targetType || 'user';

    var requestData = {
      rotation_id: payload.rotationId,
      start_date: payload.startDate,
      end_date: payload.endDate,
      target_type: targetType,
      force_save: forceSave
    };

    // Add the appropriate ID based on target type
    if (targetType === 'user' || !targetType) {
      requestData.user_id = payload.targetId;
    } else if (targetType === 'position') {
      requestData.position_id = payload.targetId;
    } else if (targetType === 'job_site') {
      requestData.job_site_id = payload.targetId;
    }

    // Add required_employees for position/job_site schedules
    if (payload.requiredEmployees) {
      requestData.required_employees = payload.requiredEmployees;
    }

    $.ajax({
      url: config.routes.createDepartmentRotationPath,
      type: 'POST',
      data: JSON.stringify(requestData),
      contentType: 'application/json',
      dataType: 'json'
    })
  };

  var openConflictDialogue = function(data, responseData) {
    // Normalize snake_case from worker to camelCase for JavaScript
    var normalizedPayload = {
      rotationId: data.rotation_id,
      targetType: data.target_type,
      targetId: data.user_id || data.position_id || data.job_site_id,
      startDate: data.start_date,
      endDate: data.end_date
    };

    // Preserve required_employees if present
    if (data.required_employees) {
      normalizedPayload.requiredEmployees = data.required_employees;
    }

    responseData.payload = normalizedPayload;

    if (responseData.other_department_conflicts) {
      openShowStopperDialogue(normalizedPayload, responseData);
    } else {
      openForceSavePrompt(normalizedPayload, responseData);
    }
  };

  var openShowStopperDialogue = function(postData, responseData) {
    hideLoader();

    var promptContent = HandlebarsTemplates['rotations/rotation_show_stopper']({
      applying: I18n.t('rotations.js.applying'),
      conflicts: I18n.t('rotations.js.conflicts'),
      shift: I18n.t('rotations.js.shift'),
      time_off_block: I18n.t('rotations.js.time_off_block'),
      errors: responseData.errors
    });

    bootbox.dialog(promptContent, [
      {
        "label" : I18n.t('rotations.js.cancel'),
        "class" : "btn-danger",
        "callback": function() {
          hideLoader();
        }
      }
    ]);
  };

  // Open a modal prompting the user to save the rotation and delete conflicting shifts
  var openForceSavePrompt = function(data, responseData) {
    hideLoader();

    // Customize message based on target type
    var targetType = responseData.target_type || 'user';
    var isRequirement = targetType === 'position' || targetType === 'job_site';

    var promptContent = HandlebarsTemplates['rotations/rotation_warning']({
      rotation_warning: I18n.t('rotations.js.rotation_warning'),
      applying_rotation: isRequirement
        ? I18n.t('rotations.js.applying_rotation_requirements')
        : I18n.t('rotations.js.applying_rotation'),
      shift: I18n.t('rotations.js.shift'),
      shift_requirement: I18n.t('rotations.js.shift_requirement'),
      time_off_block: I18n.t('rotations.js.time_off_block'),
      note: I18n.t('rotations.js.note'),
      note_detail: isRequirement
        ? I18n.t('rotations.js.note_detail_requirements')
        : I18n.t('rotations.js.note_detail'),
      short_errors: responseData.short_errors,
      total_errors: responseData.total_errors,
      is_requirement: isRequirement
    });

    var continueLabel = isRequirement
      ? I18n.t('rotations.js.continue_delete_requirements')
      : I18n.t('rotations.js.continue');

    bootbox.dialog(promptContent, [
      {
        "label" : I18n.t('buttons.cancel'),
        "class" : "btn",
        "callback": function() {
          hideLoader();
        }
      },
      {
        "label" : continueLabel,
        "class" : "btn-danger",
        "callback": function() {
          postData(responseData.payload, true);
        }
      }
    ]);
  }

  var buildDialogMessage = function(nextDay, targetType) {
    const formattedDate = $.datepicker.formatDate("yy-mm-dd", nextDay);
    const rotationEndLabel = I18n.t('rotations.js.rotation_end');
    const requiredEmployeesLabel = I18n.t('rotations.js.required_employees');

    // Add Required Employees field for position and job_site schedules only
    if (targetType === 'position' || targetType === 'job_site') {
      return `
        <div>
          <div style='display: flex; align-items: flex-start; gap: 60px;'>
            <div>
              <label style='margin-bottom: 10px; display: block;'><strong>* ${rotationEndLabel}</strong></label>
              <div class='datepicker' id='dater' data-date-format='yyyy-mm-dd'>
                <input type='hidden' id='rotation-end-date' value='${formattedDate}' readonly text-align:center;'>
              </div>
            </div>
            <div class='control-group' id='rotation-required-employees-control-group' style='margin-top: 0;'>
              <label class='control-label' for='rotation-required-employees'><strong>* ${requiredEmployeesLabel}</strong></label>
              <div class='controls'>
                <input type='number' id='rotation-required-employees' class='form-control numeric integer required' min='1' max='${MAX_INT}' step='1' value='1' />
                <span class='help-inline' id='rotation-required-employees-error' style='display: none; color: #b94a48;'></span>
              </div>
            </div>
          </div>
        </div>
      `;
    } else {
      return `
        <div>
          <label style='margin-bottom: 10px; display: block;'><strong>* ${rotationEndLabel}</strong></label>
          <div class='datepicker' id='dater' data-date-format='yyyy-mm-dd'>
            <input type='hidden' id='rotation-end-date' value='${formattedDate}' readonly text-align:center;'>
          </div>
        </div>
      `;
    }
  };

  return {
    init: init,
    openModal: openModal
  }

})(jQuery, window, document);
